import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
// import {provider} from "@metamask/detect-provider";
import { Col, Container, Input, Label, Row } from "reactstrap";
import { Btn, H1, H6, P, Image } from "../../AbstractElements";
import { dynamicImage } from '../../Service';
import { Formik, Field, Form, ErrorMessage } from "formik";
import moment from 'moment';
import { toast } from "react-toastify";
import Loader from '../../CommonElements/Loader/Loader';
import * as Yup from 'yup';
import { RegistrationFormPropsType, RegistrationForminitialValues, SignupPropsType } from "../../Type/Forms/FormsType";
import { useRegisterService } from '../../Service/Authentication/RegisterationService';
import { useSweetAlert } from '../../Context/SweetAlertContext'
import { encryptData, decryptData, } from "../../utils/helper/Crypto";
import { ethers , BrowserProvider } from "ethers";
import Web3 from 'web3';
import { useDepositFundService } from '../../Service/DepositFund/DepositFundINRAED';


// Declare `window.ethereum` globally
declare global {
  interface Window {
    ethereum?: any;
  }
}

const RegisterWithBgImageContainer = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [FormFieldData, setFormFieldData] = useState<any>(null)
  const [pageloader, setpageloader] =useState(false)
  const { registerMember,ExecuteProcedure, loading } = useRegisterService();
  const {SignUpDAPP}= useDepositFundService();
  const [walletAddress, setWalletAddress] = useState<string | null>(null);
  const {showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert()
  const uname = queryParams.get('uname');
  const navigate=useNavigate();
const [usdtBalance, setUsdtBalance] = useState(0);
const [bnbBalance, setBnbBalance] = useState(0);
const [error, setError] = useState(null);
const [joiningamount,setjoiningamount]=useState<string>();

  const validationSchema = Yup.object({
    Wallet: Yup.string().required('Wallet Address is required'),
    JoiningAmt:Yup.string().required('Joining Amount is required'),
  });
  const SignUP=async(SignUpObj:any)=>{
    setpageloader(true);
    console.log("Form Values: ", SignUpObj); // Check if values are correct
    try {
      setpageloader(true);
      const result = await SignUpDAPP(SignUpObj);
      if (result) {
      
        console.log(result);
        var parts = result.split('|');
        var resultCode = parts[0];
        if (resultCode == "Success") {
            ShowSuccessAlert(parts[1]);
       
            localStorage.setItem("UserId", parts[2]);
            localStorage.setItem("ReferralURL", parts[4] + parts[3]);
          
           // $("#cover-spin").hide();
          
          localStorage.setItem("clientId", encryptData(parts[2]?.toString()));

          localStorage.setItem("userToken", encryptData(parts[5].toString()));
          localStorage.setItem("UserName", parts[3]);
          localStorage.setItem("refURL", parts[4] + parts[3]);
          localStorage.setItem("MemberName", parts[6].toString())
         
          setTimeout(() => {
            setpageloader(false);
            navigate(`${import.meta.env.BASE_URL}/dashboard`);
          }, 1000);
        }
        else {
           // $('#btnRegister').attr("disabled", false);
            showAlert(parts[1]);
            setpageloader(false);
        }
      
      } else {
  
      }

    } catch (error) {
      console.error("Error in registration: ", error);
      setpageloader(false);
    }
  }

  const HandleRegisterSubmit = async (values: RegistrationFormPropsType) => {
    setpageloader(true)
    console.log("Form Values: ", values); // Check if values are correct
    try {
      const {JoiningAmt} = values;
      setjoiningamount(JoiningAmt);
      ValidateTransaction(JoiningAmt);
      setjoiningamount(JoiningAmt);
    } catch (error) {
      console.error("Error in registration: ", error);
    }
  };
///---------------------DAPP--------------------------------

//const uplineId = 0;
//Mainnet
const contractAddress = '0xA200D4f5997Cc311f59d4C751e2C8c9aE36f99Ff'; // Contract Address
const contractABI = [{"inputs":[{"internalType":"address","name":"_usdtTokenAddress","type":"address"},{"internalType":"address","name":"_withdrawContract","type":"address"},{"internalType":"uint256","name":"_withdrawPercentage","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"inputs":[],"name":"autoWithdrawPer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"changeOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"withdrawPercentage","type":"uint256"}],"name":"setAutoWithdrawPer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newWithdrawContract","type":"address"}],"name":"setWithdrawContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalWithdraw","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"toWithdrawCon","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferToWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"transferToWithdrawContract","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"usdtToken","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userBalances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]

const usdtAddress = "0x55d398326f99059ff775485246999027b3197955"; // USDT contract address on BSC
const usdtABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];

useEffect(() => {
  const initialize = async () => {
    await Promise.all([connectWallet(), Check_Sponsor()]);
  };

  initialize();

}, []); // Empty dependency array means this runs once when the component mounts


  const connectWallet = async () => {
    if (!window.ethereum) {
      alert("MetaMask is not installed. Please install it!");
      return;
    }
  
    try {
      const provider = new BrowserProvider(window.ethereum); // v6 syntax
      const accounts = await provider.send("eth_requestAccounts", []);
      const balanceInWei = await provider.getBalance(accounts[0]);
      const balanceInEth = ethers.formatEther(balanceInWei);
      console.log(balanceInEth);
     
      const FordData ={
        Wallet:accounts[0],
        JoiningAmt:''
      }
      debugger
      setFormFieldData(FordData)
      console.log("Connected Account:", accounts[0]);
    //  USDTBalanceComponent(accounts[0]);
    setWalletAddress(accounts[0]);
    const usdtAddress = "0x55d398326f99059ff775485246999027b3197955"; // USDT contract address on BSC
   const usdtABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];


      const web3 = new Web3('https://bsc-dataseed.binance.org/'); // Public BSC RPC URL

      const myContract = new web3.eth.Contract(usdtABI, usdtAddress);

      try {
          if (!web3.utils.isAddress(accounts[0])) {
              throw new Error('Invalid address format.');
          }

          // Fetch USDT balance
          const balance:any = await myContract.methods.balanceOf(accounts[0]).call();
          const formattedBalance = web3.utils.fromWei(balance, 'mwei'); // USDT uses 6 decimal places

          // Fetch BNB balance
          const bnbBalanceWei = await web3.eth.getBalance(accounts[0]);
          const formattedBalanceBNB = web3.utils.fromWei(bnbBalanceWei, 'ether'); // BNB uses 18 decimals

          // Format the result
          const USDTresult:number = parseFloat(formattedBalance) / 10 ** 12; // USDT uses 6 decimals
          const BNBResult:number = parseFloat(formattedBalanceBNB);

          // Set the state values
          setUsdtBalance(USDTresult);
          setBnbBalance(BNBResult);
          console.log ("USDTresult: "+USDTresult);
          console.log ("BNBResult: "+BNBResult);

      } catch (error) {
         // setError('Error fetching balances: ' + error.message);
      } finally {
        setpageloader(false);
      }

    } catch (error) {
      showAlert("Could not Connected to the MetaMask")
      console.error("Error connecting to MetaMask:", error);
    }
  };
 ////-----------------------------DAPP wallet Get------------------------------
 const ValidateTransaction = async (SlotAmount:any) => {
  
    const obj=
    {  WalletAddress : walletAddress,
     PayAmount : SlotAmount

    }
    const Param ={
      procName:'ValidateTransactionReg',
      Para:JSON.stringify(obj)
    }
    const result = await ExecuteProcedure(Param);
    if (result[0].StatusCode == "1") {
      setpageloader(false);
      if (bnbBalance < 0.0020) {
        
          showAlert("Insufficient bnb Balance on payment");
          // $("#cover-spin").hide();
          // return
      }
      if (result[0].Amount > usdtBalance) {
          
          showAlert("Insufficient USDT balance on payment");
         // $("#cover-spin").hide();
       
          return
      }
      approveAndDeposit(result[0].Amount * 10 ** 12,result[0].Amount);
      
  } else {
    showAlert(result[0].Msg);
     // $("#cover-spin").hide();
     setpageloader(false);
  }
 }
//  Checking Sponsor at the register time
const Check_Sponsor = async()=>{
  if(!uname){
    showAlert('Access Denied', 'Sponsor not Available')
  } else {
    const obj=
    {UserName:uname,
      ActionMode:"CheckSponsor"

    }
    const Param ={
      procName:'CheckSponsorReg',
      Para:JSON.stringify(obj)
    }
    
    const res = await ExecuteProcedure(Param);
    if(res[0]?.StatusCode == 0){
      showAlert(res[0].Msg);
    }
    
  }
}
const approveAndDeposit = async (amount:number,slotamount:number) => {
  setpageloader(true);
  if (!amount || isNaN(amount)) {
    alert("Please enter a valid amount.");
    setpageloader(false);  // Hide the loading spinner
    return;
  }

  try {
    setpageloader(true);  // Show the loading spinner

    await connectWallet(); // Load Web3 and MetaMask connection
    console.log('Web3 Loaded Successfully.');

    console.log('Approving USDT...');
    const approvalSuccess = await approveTokens(amount); // Step 1: Approve USDT tokens
    console.log('USDT Approved.');

    console.log('Depositing USDT...');
    if (approvalSuccess) {
      await depositTokens(amount,slotamount); // Step 2: Deposit USDT tokens into your contract
      console.log('USDT Deposited.');
    } else {
      setpageloader(false);
      showAlert("Approval failed");
    }
  } catch (error) {
    setpageloader(false); 
    console.error('Error during the approval and deposit process:', error);
    showAlert("An error occurred during the process");
  } finally {
    setpageloader(false); // Hide the loading spinner after process completes
  }
};

// Approve USDT Tokens
const approveTokens = async (amount: number) => {
  try {
    if (typeof window.ethereum === 'undefined') {
      console.error('Ethereum provider is not available.');
      setpageloader(false); 
      return;
    }

    const web3 = new Web3(window.ethereum); // Use the window.ethereum provider
    await window.ethereum.request({ method: 'eth_requestAccounts' }); // Request MetaMask accounts

    const usdtContract = new web3.eth.Contract(usdtABI, usdtAddress);

    const accounts = await web3.eth.getAccounts();
    const userAddress = accounts[0]; // Get the first account
    const usdtAmount = web3.utils.toWei(amount.toString(), 'mwei'); // Convert amount to USDT (6 decimals)

    // Send approval transaction
    const receipt = await usdtContract.methods
      .approve(contractAddress, usdtAmount)
      .send({ from: userAddress });

    // Check if the transaction was successful
    if (receipt.status) {
      console.log('Approval successful');
      return true;
    } else {
      console.error('Approval failed');
      return false;
    }
  } catch (error) {
    console.error('An error occurred during approval:', error);
    alert('Approval failed. Please try again');
    setpageloader(false); 
    return false;
  }
};

// Deposit USDT Tokens
const depositTokens = async (amount:number,slotamount:number) => {
  try {
    setpageloader(true);
    const contractAddress = '0xA200D4f5997Cc311f59d4C751e2C8c9aE36f99Ff'; // Contract Address
const contractABI = [{"inputs":[{"internalType":"address","name":"_usdtTokenAddress","type":"address"},{"internalType":"address","name":"_withdrawContract","type":"address"},{"internalType":"uint256","name":"_withdrawPercentage","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"inputs":[],"name":"autoWithdrawPer","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"changeOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"withdrawPercentage","type":"uint256"}],"name":"setAutoWithdrawPer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newWithdrawContract","type":"address"}],"name":"setWithdrawContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalDeposit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalWithdraw","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"toWithdrawCon","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferToWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"transferToWithdrawContract","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"usdtToken","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userBalances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"}]

    //const web3 = new Web3('https://bsc-dataseed.binance.org/'); // Public BSC RPC URL
    const web3 = new Web3(window.ethereum); // Use the window.ethereum provider
    await window.ethereum.request({ method: 'eth_requestAccounts' }); // Request MetaMask accounts

    const smartContract = new web3.eth.Contract(contractABI, contractAddress);
if (typeof window.ethereum === 'undefined') {
      console.error('Ethereum provider is not available.');
      setpageloader(false);
      return;
    }

    const accounts = await web3.eth.getAccounts();
    const userAddress = accounts[0]; // Get the first account
    const usdtAmount = web3.utils.toWei(amount.toString(), "mwei"); // Convert amount to USDT (6 decimals)

    console.log('USDT Amount:', usdtAmount);

    await smartContract.methods.deposit(usdtAmount)
      .send({ from: userAddress })
      .on('transactionHash',  (hash:any)=> {
        console.log('Deposit transaction sent:', hash);
        const WalletAddress=userAddress;
        const TxnHash=hash;
        const SlotAmount=slotamount;
        const SponsorUserName=queryParams.get('uname');
        const PackageId=1;
        debugger
       const obj= {SlotAmount,TxnHash,WalletAddress,SponsorUserName,PackageId}
        SignUP(obj);
      
      })
      .on('receipt',  (receipt:any)=> {
        console.log('Deposit transaction receipt:', receipt);
      })
      .on('error',  (error:any)=> {
        console.error('Deposit error:', error);
        showAlert("Transaction Failed");
        setpageloader(false);
      });
  } catch (error) {
    setpageloader(false);
    console.error('An error occurred during deposit:', error);
    showAlert("TDeposit failed. Please try again.");
  } finally {
    setpageloader(false);  // Hide loading spinner once done
  }
};
 //--------------------------------------------------------------------------

  return (
    <Container fluid className="p-0 login_tree_image">
      {pageloader && <Loader />}
      <Row className="m-0 justify-content-center">
        <Col xl="5" className="p-0">
          <div className="login-card" style={{ borderRadius: '0px' }}>
            <div>
              <div className="login-main" style={{ width: '100%'}}>
                <Formik
                  initialValues={FormFieldData || RegistrationForminitialValues}
                  validationSchema={validationSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    HandleRegisterSubmit(values);
                    setSubmitting(false);
                  }}
                  enableReinitialize
                >
                  {({ isSubmitting, values, setFieldValue, setFieldError }) => (
                    <Form className="theme-form">
                      <Row>
                        <Col xs="12" md="4">
                          <center>
                            <Image
                              className="img-fluid"
                              src={dynamicImage("login/tmc logo final.png")}
                              style={{ height: "60px", margin: "auto" }}
                              alt="logo"
                            />
                          </center>
                        </Col>
                        <Col xs="12" md="8" className='mt-3 mt-md-0'>
                        <H1 className="text-center f-30 text-white">Create Your Account</H1>
                        <P className="text-center m-0" >{"With Your Trust Me CE Account"}</P>
                        </Col>
                      </Row>

                      <hr  style={{ borderStyle: 'inset', borderColor: '#00738b57',marginTop:'25px',marginBottom:'25px' }} />
                     
                      <div className="form-group">
                        <Row className="g-2">
                          <Col xs="12 mb-3">
                            <Label className="col-form-label pt-0">WALLET</Label>
                            <Field
                            style={{borderRadius: '20px'}}
                              name="Wallet"
                              value={values.Wallet}
                              placeholder="Your Wallet Address"
                              className="form-control"
                              readOnly
                            />
                            <ErrorMessage name="Wallet" component="div" className="text-danger" />
                          </Col>
                          <Col xs="6 mb-3">
                            <Label className="col-form-label pt-0">CHAIN NAME</Label>
                            <Field
                             style={{borderRadius: '20px'}}
                              name="ChainName"
                              value="BEP-20 Chain"
                              placeholder="Enter Chain Name"
                              className="form-control"
                              readOnly
                            />
                            <ErrorMessage name="ChainName" component="div" className="text-danger" />
                          </Col>
                          <Col xs="6">
                            <Label className="col-form-label pt-0">JOINING AMOUNT</Label>
                            <Field
                            as="select"
                             style={{borderRadius: '20px'}}
                              name="JoiningAmt"
                              value={values.JoiningAmt}
                              placeholder="Enter Joining Amount"
                              className="form-select form-control rounded-5 border-0">
                              <option value=''>Select Joining Amt.</option>
                            
                              <option value='1'>1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                            </Field>
                            <ErrorMessage name="JoiningAmt" component="div" className="text-danger" />
                          </Col>
                          <Col xs="12">
                            <div className="form-group mb-0 checkbox-checked">
                              <Btn block color="primary" type="submit"
                                disabled={isSubmitting} style={{ backgroundColor: '#30b5b1', color: '#131111', borderColor: '#30b5b1', borderRadius: '20px' }} className="w-100 mt-3">
                                Create Account
                              </Btn>
                            </div>
                          </Col>
                          <Col xs="12" md="6">
                            <Link className="w-100 btn mt-3" to={`${import.meta.env.BASE_URL}/login`} style={{ color: '#fff', backgroundColor: '#2d2e56', borderRadius: '20px' }}>Already Registered?  Sign In</Link>
                          </Col>
                          <Col xs="12" md="6">
                            <Link className="w-100 btn mt-md-3 mt-sm-1" to={`${import.meta.env.BASE_URL}/login`} style={{ color: '#27e3e2', borderColor: '#30b5b1', borderRadius: '20px' }}>Chat_Telegram on_TrustMe</Link></Col>
                          <Col xs="12">
                            <center className='mt-3 text-white'>We Support</center></Col>
                          <Col xs="2"></Col>
                          <Col xs="4">
                            <center>
                              <Image
                                className="img-fluid W-100"
                                src={dynamicImage("login/full-trust-wallet-logo.png")}
                                style={{ margin: "auto", backgroundColor: '#fff', height: '50px', padding: '10px', borderRadius: '10px' }}
                                alt="logo"
                              />
                            </center>
                          </Col>
                          <Col xs="4">
                            <center>
                              <Image
                                className="img-fluid"
                                src={dynamicImage("login/metamask-logo-png.png")}
                                style={{ margin: "auto", backgroundColor: '#fff', height: '50px', padding: '10px', borderRadius: '10px' }}
                                alt="logo"
                              />
                            </center>
                          </Col>
                          <Col xs="2"></Col>
                        </Row>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default RegisterWithBgImageContainer;
